$(document).on('submit', '[data-checkout-form]', function(event) {
  const $form = $('[data-datatrans-form]');
  if ($form.length > 0) {
    event.preventDefault();

    const params = {};
    const excludes = ['csrfmiddlewaretoken'];
    $(this).serializeArray().filter(param => !excludes.includes(param.name)).forEach((param) => {
      params[param.name] = param.value;
    });

    window.Datatrans.startPayment({
      form: '[data-datatrans-form]',
      params,
      closed: () => {
        $('[data-checkout-form] button[type="submit"], button[type="submit"][form="checkout-form"]').each(function() {
          this.disabled = false;
        });
      },
    });
  }
});
